import Vue from 'vue';
import KassabuchService from './kassabuch.service';
import * as _ from 'lodash';

const getDefaultItem = () => ({
    kassabuch: [
        {
            id: null,
            date: null,
            belegnummer: null,
            kontonummer: null,
            text: null,
            lieferant: null,
            typ: null,
            mehrwertssteuer: {},
            betrag: null,
        },
    ],
    completeBalance: null,
    actualBalance: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    currentPage: 0,
    totalPages: 1,
});

const kassabuch = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Object.assign(state, getDefaultState());
        },
        addPosition(state, data) {
            if (data == null) data = getDefaultItem().kassabuch[0];
            state.item.kassabuch.content.push(data);
        },
        removePosition(state, data) {
            state.item.kassabuch.content = data;
        },
        updateCurrentPage(state, data) {
            Vue.set(state, 'currentPage', data);
        },
        updateTotalPages(state, data) {
            Vue.set(state, 'totalPages', data);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        addPosition(context, position) {
            context.commit('addPosition', position);
        },
        removePosition(context, data) {
            context.commit('removePosition', data);
        },
        async create(context, client_data) {
            const { data } = await KassabuchService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await KassabuchService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, params) {
            const { headers, data } = await KassabuchService.getKassabuch(params.slug, params);
            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await KassabuchService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await KassabuchService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        currentPage(state) {
            return state.currentPage;
        },
        totalPages(state) {
            return state.totalPages;
        },
    },
};

export default kassabuch;
